import type {
  CheckoutFragment,
  CheckoutLineFragment,
} from '@/graphql/saleor/api';
import { MOCK_DEFAULT_VALUE, VOUCHER_TYPE } from '@/lib/const';

import type { WithRequired } from './tsutils';

export const getCheckoutLineUnitPriceWithoutDiscount = (
  checkoutLine: WithRequired<Partial<CheckoutLineFragment>, 'unitPrice'>,
  voucherType?: string,
) => {
  const { undiscountedUnitPrice, unitPrice } = checkoutLine;

  if (
    !undiscountedUnitPrice ||
    undiscountedUnitPrice.amount === 0 ||
    voucherType === VOUCHER_TYPE.PERCENTAGE
  )
    return unitPrice;

  return {
    ...unitPrice,
    gross: {
      ...unitPrice.gross,
      amount: undiscountedUnitPrice.amount,
    },
    net: {
      ...unitPrice.net,
      amount: undiscountedUnitPrice.amount,
    },
  };
};

interface CheckoutAddressesToUpdate {
  billingAddressToUpdate: boolean;
  shippingAddressToUpdate: boolean;
}

export const isCheckoutAddressesMissing = (
  checkout: CheckoutFragment,
): CheckoutAddressesToUpdate => {
  const shippingMissing =
    !checkout.shippingAddress ||
    checkout.shippingAddress.firstName === '' ||
    checkout.shippingAddress.lastName === '' ||
    checkout.shippingAddress.streetAddress1 === '' ||
    checkout.shippingAddress.city === '' ||
    checkout.shippingAddress.postalCode === '';

  const billingMissing =
    !checkout.billingAddress ||
    checkout.billingAddress.firstName === '' ||
    checkout.billingAddress.lastName === '' ||
    checkout.billingAddress.streetAddress1 === '' ||
    checkout.billingAddress.city === '' ||
    checkout.billingAddress.postalCode === '';

  return {
    shippingAddressToUpdate: shippingMissing,
    billingAddressToUpdate: billingMissing,
  };
};

export const isCheckoutAddressesMocked = (
  checkout: CheckoutFragment,
): CheckoutAddressesToUpdate => {
  const shippingMocked =
    checkout.shippingAddress?.firstName === MOCK_DEFAULT_VALUE ||
    checkout.shippingAddress?.lastName === MOCK_DEFAULT_VALUE ||
    checkout.shippingAddress?.streetAddress1 === MOCK_DEFAULT_VALUE ||
    checkout.shippingAddress?.city === MOCK_DEFAULT_VALUE ||
    checkout.shippingAddress?.postalCode === MOCK_DEFAULT_VALUE ||
    checkout.shippingAddress?.countryArea === MOCK_DEFAULT_VALUE;

  const billingMocked =
    checkout.billingAddress?.firstName === MOCK_DEFAULT_VALUE ||
    checkout.billingAddress?.lastName === MOCK_DEFAULT_VALUE ||
    checkout.billingAddress?.streetAddress1 === MOCK_DEFAULT_VALUE ||
    checkout.billingAddress?.city === MOCK_DEFAULT_VALUE ||
    checkout.billingAddress?.postalCode === MOCK_DEFAULT_VALUE ||
    checkout.billingAddress?.countryArea === MOCK_DEFAULT_VALUE;

  return {
    shippingAddressToUpdate: shippingMocked,
    billingAddressToUpdate: billingMocked,
  };
};
